import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import FirebaseHandler from "../../firebase";
import { httpsCallable } from "firebase/functions";
export var buyMagazine = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(data) {
        var magazineBuy;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        magazineBuy = httpsCallable(FirebaseHandler.functions, "magazineBuy");
                        return _context.abrupt("return", magazineBuy(data));
                    case 2:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee);
    }));
    return function buyMagazine(_x) {
        return _ref.apply(this, arguments);
    };
}();
